module.exports = __webpack_public_path__ + "img/text_2.b7deb896.svg";